import { fetcher } from "@/lib/api/fetcher";
import { environments } from "@/lib/config";

const apiUrl = environments.restApiUrl;

export type AddressRequest = {
  country_code?: string;
  city_code?: string;
  district?: string;
};

export type BoundData = {
  max_x: number;
  max_y: number;
  min_x: number;
  min_y: number;
};

export const getAddress = (queryParams?: AddressRequest) => {
  return fetcher(`${apiUrl}/address/by_code`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    queryParams,
  });
};

export const getBoundInit = () => {
  return fetcher(`${apiUrl}/common/bounds`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
